import React from "react";
import { FaQuestionCircle } from "react-icons/fa";

const FAQs = () => {
  return (
    <div className="container-fluid py-5" style={{ marginTop: "110px" }}>
      {/* PAGE TITLE */}
      <h2
        className="text-center fw-bold mb-5"
        style={{ color: "#cc9051", fontSize: "32px" }}
      >
        Frequently Asked Questions
      </h2>

      <div className="row justify-content-center">
        <div className="col-lg-10">
          {/* FAQ CARD */}
          <div
            className="card border-0 rounded-4 p-4 p-md-5"
            style={{ fontSize: "16px", lineHeight: "1.8" }}
          >
            {/* ACCORDION */}
            <div className="accordion accordion-flush" id="faqAccordion">

              {/* ITEM 1 */}
              <div className="accordion-item mb-3 rounded-3 border">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq1"
                  >
                    <FaQuestionCircle className="me-2 text-warning" /> What types of artwork do you offer?
                  </button>
                </h2>
                <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    We offer original artwork, high-quality prints on canvas, and premium card prints.
                  </div>
                </div>
              </div>

              {/* ITEM 2 */}
              <div className="accordion-item mb-3 rounded-3 border">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq2"
                  >
                    <FaQuestionCircle className="me-2 text-warning" /> What are the payment options?
                  </button>
                </h2>
                <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    We accept secure online payments through credit/debit cards, UPI, wallets, PayPal, and more.
                  </div>
                </div>
              </div>

              {/* ITEM 3 */}
              <div className="accordion-item mb-3 rounded-3 border">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq3"
                  >
                    <FaQuestionCircle className="me-2 text-warning" /> How long does shipping take?
                  </button>
                </h2>
                <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Typically, 7–10 days for domestic delivery and 14–25 days for international delivery.
                  </div>
                </div>
              </div>

              {/* ITEM 4 */}
              <div className="accordion-item mb-3 rounded-3 border">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq4"
                  >
                    <FaQuestionCircle className="me-2 text-warning" /> How do I care for my artwork?
                  </button>
                </h2>
                <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Keep artwork away from direct sunlight, moisture, and high temperatures for long life.
                  </div>
                </div>
              </div>

              {/* ITEM 5 */}
              <div className="accordion-item mb-3 rounded-3 border">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq5"
                  >
                    <FaQuestionCircle className="me-2 text-warning" /> Can I purchase artwork as a gift?
                  </button>
                </h2>
                <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Yes! Artwork makes a perfect gift. You can include a custom message with your order.
                  </div>
                </div>
              </div>

              {/* ITEM 6 */}
              <div className="accordion-item mb-3 rounded-3 border">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq6"
                  >
                    <FaQuestionCircle className="me-2 text-warning" /> What is the Certificate of Authenticity?
                  </button>
                </h2>
                <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Every artwork comes with a certificate signed by the artist including:
                    <ul className="mt-2">
                      <li>Artwork title & description</li>
                      <li>Artist’s signature</li>
                      <li>Date of creation</li>
                      <li>Materials used</li>
                      <li>Unique certificate number</li>
                    </ul>
                    This certifies that your artwork is 100% authentic.
                  </div>
                </div>
              </div>

            </div>
            {/* END ACCORDION */}
          </div>
          {/* END CARD */}
        </div>
      </div>
    </div>
  );
};

export default FAQs;
